import { TextStyle, View, ViewStyle } from "react-native"

import MaterialIcons from "@expo/vector-icons/MaterialIcons"

import { Text } from "src/components/Ignite/Text"
import { useAppTheme } from "src/hooks/useAppTheme"
import { ThemedStyle } from "src/theme"

interface AudioThumbnailProps {
  title?: string
}

export const AudioThumbnail = ({ title }: AudioThumbnailProps) => {
  const { themed, theme } = useAppTheme()

  return (
    <View style={themed($container)}>
      <View style={themed($iconContainer)}>
        <MaterialIcons name="volume-up" size={60} color={theme.colors.buttonText} />
      </View>
      <View style={themed($textContainer)}>
        <Text
          text={title || "Audio File"}
          style={themed($audioTitle)}
          numberOfLines={4}
          ellipsizeMode="tail"
        />
      </View>
      <View style={themed($playIconContainer)}>
        <MaterialIcons name="play-circle-filled" size={32} color={theme.colors.buttonText} />
      </View>
    </View>
  )
}

const $container: ThemedStyle<ViewStyle> = ({ colors, spacing }) => ({
  flexDirection: "row",
  alignItems: "center",
  backgroundColor: colors.buttonBackground,
  borderRadius: 12,
  padding: spacing.sm,
  marginBottom: spacing.sm,
  width: 280,
})

const $iconContainer: ThemedStyle<ViewStyle> = ({ colors, spacing }) => ({
  width: 80,
  height: 80,
  backgroundColor: colors.buttonBackground,
  borderRadius: 8,
  justifyContent: "center",
  alignItems: "center",
  marginRight: spacing.md,
})

const $textContainer: ThemedStyle<ViewStyle> = () => ({
  flex: 1,
  justifyContent: "center",
})

const $audioTitle: ThemedStyle<TextStyle> = ({ colors, typography }) => ({
  color: colors.buttonText,
  fontSize: 16,
  fontFamily: typography.fonts.figtree.medium,
  marginBottom: 4,
})

const $playIconContainer: ThemedStyle<ViewStyle> = ({ spacing }) => ({
  marginLeft: spacing.sm,
})
